export default __webpack_public_path__ + "images/fi_calendar.svg";